export default __webpack_public_path__ + "static/avatar-special-halloween-0-detail-74c886e1f949a68651f97e67d9072b40.png";